import { useCallback, useEffect, useState } from "react";
import { api, errMsg } from "../lib/api";


function strikeId() {
  if (window.crypto?.randomUUID) return window.crypto.randomUUID();
  return `${Date.now()}-${Math.random().toString(16).slice(2)}`;
}


export function useMiningGame(onBalanceChange) {
  const [game, setGame] = useState(null);
  const [loading, setLoading] = useState(true);
  const [striking, setStriking] = useState(false);
  const [error, setError] = useState("");
  const [lastReward, setLastReward] = useState(null);

  const load = useCallback(async () => {
    try {
      const response = await api.get("/mining/state");
      setGame(response.data);
      setError("");
      onBalanceChange?.(response.data.balance);
    } catch (requestError) {
      setError(errMsg(requestError));
    } finally {
      setLoading(false);
    }
  }, [onBalanceChange]);

  useEffect(() => { load(); }, [load]);

  const strike = useCallback(async () => {
    if (striking || !game?.can_strike) return;
    setStriking(true);
    setError("");
    try {
      const response = await api.post("/mining/strike", { strike_id: strikeId() });
      setGame(response.data);
      setLastReward({ value: response.data.reward, key: Date.now(), dispatched: response.data.wagon_dispatched });
      onBalanceChange?.(response.data.balance);
    } catch (requestError) {
      setError(errMsg(requestError));
      await load();
    } finally {
      setStriking(false);
    }
  }, [game?.can_strike, load, onBalanceChange, striking]);

  return { game, loading, striking, error, lastReward, strike, reload: load };
}
